interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  business?: string;
  message: string;
  plan?: string;
}

interface ContactMetadata {
  source: string;
  page_url: string;
  referrer: string;
  form_type: string;
  business_name?: string;
  selected_plan?: string;
  device_type: string;
  submitted_at: string;
}

interface ContactApiResponse {
  success: boolean;
  message: string;
  data?: {
    id: number;
    name: string;
    email: string;
    phone?: string;
    subject?: string;
    message: string;
    metadata?: ContactMetadata;
    is_read: boolean;
    created_at: string;
  };
}

const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || "https://backend.periscale.app",
  contactEndpoint: "/api/v1/business/website/contact/",
  // Business ID provided by user - fetch from database in production
  businessId: process.env.REACT_APP_BUSINESS_ID || "39b115e7-764a-48a8-b06c-1bca5d5f78e1",
};

export async function submitContactForm(
  formData: ContactFormData,
  formType: "contact_page" | "other_page" = "contact_page"
): Promise<void> {
  const payload = {
    name: formData.name,
    email: formData.email,
    phone: formData.phone || undefined,
    subject: formData.plan
      ? `Interest in ${formData.plan} Package`
      : "General Inquiry",
    message:
      formData.message +
      (formData.business ? `\n\nBusiness: ${formData.business}` : "") +
      (formData.plan ? `\n\nInterested Package: ${formData.plan}` : ""),
    metadata: {
      source: "contact_form",
      page_url: window.location.pathname,
      referrer: document.referrer,
      form_type: formType,
      business_name: formData.business || undefined,
      selected_plan: formData.plan || undefined,
      device_type: /Mobile|Android|iPhone/i.test(navigator.userAgent)
        ? "mobile"
        : "desktop",
      submitted_at: new Date().toISOString(),
    } as ContactMetadata,
  };

  const response = await fetch(
    `${API_CONFIG.baseURL}${API_CONFIG.contactEndpoint}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Business-ID": API_CONFIG.businessId,
      },
      body: JSON.stringify(payload),
    }
  );

  const data: ContactApiResponse = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Failed to submit contact form");
  }

  if (!data.success) {
    throw new Error(data.message || "Failed to submit contact form");
  }
}

export { API_CONFIG };
